(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-brands-sephora"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = value => (value || '').toLocaleLowerCase().normalize('NFKD').replace(/[\u0591-\u05C7]/g, '').replace(/[^a-z0-9\u0590-\u05ff]+/g, ' ').trim();
    document.querySelectorAll('[data-yc-brands]').forEach(root => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const input = root.querySelector('[data-yc-brand-search]');
      const cards = [...root.querySelectorAll('.yc-brand-card')];
      const groups = [...root.querySelectorAll('.yc-brand-group')];
      const empty = root.querySelector('[data-yc-brand-empty]');
      input.addEventListener('input', () => {
        const query = normalize(input.value);
        let visible = 0;
        cards.forEach(card => {
          const show = !query || normalize(card.dataset.search).includes(query);
          card.hidden = !show;
          if (show) visible += 1;
        });
        groups.forEach(group => {
          group.hidden = !group.querySelector('.yc-brand-card:not([hidden])');
        });
        empty.style.display = visible ? 'none' : 'block';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
